import {configureStore} from "@reduxjs/toolkit";
import {accountApi} from "api/AccountTableAPI";
import {auditApi} from "api/AuditTableAPI";
import {locationApi} from "api/LocationTableAPI";
import {userApi} from "api/UserTableAPI";
import {
    subscriberApi,
    subscriberAuditTypeItemsApi,
    subscriberAuditTypesApi,
    subscriberInspectionsQuestionsApi,
} from "api/SubasciberTableAPI";

export const store = configureStore({
    reducer: {
        [locationApi.reducerPath]: locationApi.reducer,
        [userApi.reducerPath]: userApi.reducer,
        [accountApi.reducerPath]: accountApi.reducer,
        [auditApi.reducerPath]: auditApi.reducer,
        [subscriberApi.reducerPath]: subscriberApi.reducer,
        [subscriberAuditTypeItemsApi.reducerPath]: subscriberAuditTypeItemsApi.reducer,
        [subscriberAuditTypesApi.reducerPath]: subscriberAuditTypesApi.reducer,
        [subscriberInspectionsQuestionsApi.reducerPath]: subscriberInspectionsQuestionsApi.reducer,
    },
    middleware: (getDefaultMiddleware) =>
        getDefaultMiddleware()
            .concat(locationApi.middleware)
            .concat(userApi.middleware)
            .concat(auditApi.middleware)
            .concat(accountApi.middleware)
            .concat(subscriberApi.middleware)
            .concat(subscriberAuditTypeItemsApi.middleware)
            .concat(subscriberInspectionsQuestionsApi.middleware)
            .concat(subscriberAuditTypesApi.middleware),
});
